// import { ReservationsFilterParams } from '@/types/Reservation'
// import { getReservationFilterParams } from '@/util/FiltersUtil'
import { useDebounce } from '@shared/hooks'

import { useFiltersContext } from '@/context'
import { UserQueries } from '@/graphql/queries/user.queries'

import { useGraphql } from '../useGraphql'

const useMembers = () => {
  const [{ searchString }] = useFiltersContext()
  const debouncedSearch = useDebounce(searchString, 1000)

  return useGraphql<UserQueries.GET_MEMBERS.Response>(UserQueries.QUERY_KEYS.getMembers, UserQueries.getMembers(), {
    search: debouncedSearch,
  })
}

export default useMembers
